<template>
  <div class="field-editor">
    <el-checkbox v-if="field.type === 'boolean'" :value="draft" :disabled="disabled" :aria-label="field.label" @change="commit" />
    <el-select
      v-else-if="field.type === 'select' || field.type === 'multi'"
      v-model="draft" :multiple="field.type === 'multi'" filterable allow-create default-first-option
      clearable :disabled="disabled" :placeholder="field.type === 'multi' ? 'Add tags' : 'Not set'"
      size="small" :aria-label="field.label" @change="commit"
    >
      <el-option v-for="option in options" :key="option" :label="option" :value="option" />
    </el-select>
    <el-popover v-else placement="bottom" width="340" trigger="click" @show="resetDraft">
      <div class="note-label">{{ field.label }}</div>
      <el-input v-model="draft" type="textarea" :rows="5" maxlength="4000" show-word-limit :disabled="disabled" :label="field.label" />
      <div class="note-actions"><el-button size="mini" type="primary" :disabled="disabled || draft === value" @click="commit(draft)">Save note</el-button></div>
      <button slot="reference" class="note-button" :disabled="disabled" :aria-label="`Edit ${field.label}`">{{ value || 'Add note…' }}</button>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'AdminOperationsFieldEditor',
  props: {
    field: { type: Object, required: true },
    value: { required: true },
    disabled: Boolean
  },
  data() { return { draft: this.copy(this.value) } },
  computed: {
    options() {
      const selected = Array.isArray(this.value) ? this.value : [this.value]
      return Array.from(new Set([...(this.field.options || []), ...selected].filter(Boolean)))
    }
  },
  watch: {
    value: { deep: true, handler(value) { this.draft = this.copy(value) } },
    disabled(value) { if (!value) this.resetDraft() }
  },
  methods: {
    copy(value) { return Array.isArray(value) ? value.slice() : value },
    resetDraft() { this.draft = this.copy(this.value) },
    commit(value) { this.draft = this.copy(value); this.$emit('save', this.copy(value)) }
  }
}
</script>

<style scoped>
.field-editor .el-select { width: 100%; }
.note-button { background: transparent; border: 0; padding: 6px 0; font: inherit; color: #52647a; cursor: pointer; text-align: left; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.note-button:hover { color: #175eae; }
.note-button:disabled { cursor: wait; opacity: .6; }
.note-label { font-weight: 600; margin-bottom: 10px; }
.note-actions { margin-top: 12px; text-align: right; }
</style>
